import { render } from "./SchemeInfo.vue?vue&type=template&id=06d36f88&scoped=true&ts=true"
import script from "./SchemeInfo.vue?vue&type=script&lang=ts"
export * from "./SchemeInfo.vue?vue&type=script&lang=ts"

import "./SchemeInfo.vue?vue&type=style&index=0&id=06d36f88&scoped=true&lang=stylus"

import exportComponent from "D:\\zhongzhi\\wuzangceping_sahngyeban\\health-WeChat-small-program-page\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06d36f88"]])

export default __exports__